import React from 'react';
import { CardProfile } from './CardProfile';

export const CardComposer = ({data, id, matchedQueries}) => {
  return (
    <CardProfile data={data.profile} id={id} model='composers' matchedQueries={matchedQueries} />
  );
};